import { ACTIVE_NETWORKS } from '@shared/utils/config/networks';
import { useEffect, useState } from 'react';
import { PiPaperPlaneTilt } from 'react-icons/pi';
import DTSendFunds from '@/components/asset/sendFunds/DTSendFunds';
import SendFundsController from '@/components/asset/sendFunds/SendFundsController';
import NetworkDropdown from '@/components/shared/NetworkDropdown';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useSession } from '@/contexts/LitSessionProvider';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { getTokenImage } from '@/lib/asset/nativeAddressHelper';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { toLocaleShortString, toSpecialFixed } from '@/lib/misc/utils';
export default function TokenToSend({
  address,
  network
}: {
  address?: string;
  network?: number;
}) {
  const isMobile = useIsMobile();
  const defaultNetwork = ACTIVE_NETWORKS;
  const [toggleNetwork, setNetwork] = useState<number[]>(defaultNetwork);
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: assetDataIsLoading
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const [showSend, setShowSend] = useState(false);
  const [tokenData, setTokenData] = useState({
    address: address || null,
    network: network || null
  });
  function handleSelectToken(assetData: any) {
    if (!assetData) return;
    const data = {
      address: assetData.contract_address || assetData.address,
      network: assetData.network
    };
    setTokenData(data);
    setShowSend(true);
  }
  useEffect(() => {
    if (address && network) {
      handleSelectToken({
        address: address,
        network: network
      });
    }
  }, [address, network]);
  if (showSend && tokenData) {
    return isMobile ? <SendFundsController tokenData={tokenData} isOpen={showSend} onClose={() => setShowSend(false)} /> : <div className=''>
        <DTSendFunds tokenData={tokenData} setShowSend={setShowSend} />
      </div>;
  }
  return <div key={`send-funds-${tokenData?.address}-${tokenData?.network}`} data-sentry-component="TokenToSend" data-sentry-source-file="TokenToSend.tsx">
      <div className='mt-4'>
        <h1 className='text-[20px] mr-3 flex font-normal ta-c justify-center items-center'>
          <PiPaperPlaneTilt className='w-[24px] h-[24px] mr-3' data-sentry-element="PiPaperPlaneTilt" data-sentry-source-file="TokenToSend.tsx" /> Send
        </h1>
      </div>
      <div className='flex items-center justify-between px-6 bg-genius-blue  w-full h-[42px] text-[14px]'>
        <p>Ticker</p>

        <NetworkDropdown setNetwork={setNetwork} network={toggleNetwork} defaultNetwork={defaultNetwork} isMobile={isMobile} className='text-[14px]  justify-center' data-sentry-element="NetworkDropdown" data-sentry-source-file="TokenToSend.tsx" />

        <p>Balance</p>
      </div>

      <ScrollArea className='h-[500px] w-full' data-sentry-element="ScrollArea" data-sentry-source-file="TokenToSend.tsx">
        <div className='mt-4 h-full pb-[100px]'>
          {assetDataIsLoading ? <p className='text-[16px] text-genius-cream'>Loading assets data...</p> : (() => {
          const sortedTokens = assetData?.balances?.filter((x: any) => x?.contract_address).filter((x: any) => {
            if (toggleNetwork) {
              return toggleNetwork?.includes(x.network);
            }
            return true;
          }).sort((a: any, b: any) => a.usd_value - b.usd_value).filter(x => x.usd_value > 0);
          return <div>
                  {sortedTokens.reverse().map((assetItem: any) => <div key={assetItem.id} onClick={() => handleSelectToken(assetItem)} className='flex items-center justify-between h-[60px] hover:bg-genius-blue px-6'>
                      <div className={`cursor-pointer`}>
                        <div className='flex items-center relative'>
                          <ImageWithFallback src={getTokenImage(assetItem)} className='shrink-0 w-[32px] h-[32px] rounded-full' alt='network logo' width={24} height={24} />
                          <ImageWithFallback src={getNetworkLogo(assetItem?.network)} className='w-[16px] h-[16px] bottom-[0px] left-4 absolute shrink-0' alt='network logo' width={10} height={10} />
                          <div className='ml-3 flex flex-col items-start whitespace-nowrap'>
                            <p className='text-[14px]'>
                              {toLocaleShortString(assetItem?.contract_name, 12)}
                            </p>
                            <p className='text-[12px] text-genius-cream/50'>
                              {toLocaleShortString(assetItem?.contract_ticker_symbol)}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p className='text-[16px] ta-r'>{`$${toSpecialFixed(assetItem.usd_value, 2)?.value}`}</p>
                        <p className='text-[12px] text-genius-cream/50 ta-r'>
                          {`${toSpecialFixed(assetItem.formatted_balance, 2)?.value} ${toLocaleShortString(assetItem.contract_ticker_symbol, 3, true)}`}
                        </p>
                      </div>
                    </div>)}
                </div>;
        })()}
        </div>
      </ScrollArea>
    </div>;
}